export const resolveVerificationEmailType = (
  result: { email_table?: string; email_type?: string },
  fallback: 'person' | 'place',
): 'person' | 'place' => {
  if (result.email_table === 'place' || result.email_type === 'place') {
    return 'place';
  }
  if (result.email_table === 'person' || result.email_type === 'person') {
    return 'person';
  }
  return fallback;
};

export const emailDataSourceToTable = (source?: string): 'person' | 'place' =>
  source === 'person' ? 'person' : 'place';
